import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const mapList = (params = '') => Http.get(`/wall-maps${serialize(params)}`)
export const mapCreate = (params = '') => Http.post('/wall-maps', params)
export const mapByID = (params = '') => Http.get(`/wall-maps/${params}`)
export const mapUpdate = (params = '') => Http.put(`/wall-maps/${params.id}`, params)
export const mapDestroy = (params = '') => Http.delete(`/wall-maps/${params.id}`)
